import React from 'react';
import { useLocation } from 'react-router-dom';
import AppBar from 'components/AppBar';

const App = () => {
  const location = useLocation();

  const isHeaderHidden = () => {
    return (location.pathname?.includes('/account-setup') || location.location?.pathname?.includes('/account-setup'));
  };

  if (isHeaderHidden()) return null;
  return (
    <AppBar location={location} />
  );
};

export default App;
